var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProLockedGraphics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 77,
    viewBox: "0 0 128 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9592 76.3294C99.2829 76.3294 127.918 74.4938 127.918 72.2296C127.918 69.9653 99.2829 68.1298 63.9592 68.1298C28.6355 68.1298 0 69.9653 0 72.2296C0 74.4938 28.6355 76.3294 63.9592 76.3294Z",
    fill: "#F5F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6478 20.9554V25.2998C84.5278 26.8231 88.0834 31.2407 88.0834 36.5172V50.505C88.0834 57.0372 82.6679 62.3334 75.9914 62.3334H52.0117C45.3323 62.3334 39.9167 57.0372 39.9167 50.505V36.5172C39.9167 31.2407 43.4753 26.8231 48.3524 25.2998V20.9554C48.3812 12.5086 55.3773 5.66669 63.9569 5.66669C72.6517 5.66669 79.6478 12.5086 79.6478 20.9554ZM64.0145 10.594C69.859 10.594 74.6094 15.2397 74.6094 20.9554V24.6888H53.3907V20.8991C53.4195 15.2116 58.17 10.594 64.0145 10.594ZM66.5193 46.6223C66.5193 48.002 65.3964 49.1001 63.9857 49.1001C62.6037 49.1001 61.4809 48.002 61.4809 46.6223V40.3717C61.4809 39.0202 62.6037 37.9221 63.9857 37.9221C65.3964 37.9221 66.5193 39.0202 66.5193 40.3717V46.6223Z",
    fill: "#2772FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLockedGraphics);
export default __webpack_public_path__ + "static/media/pro-locked-graphics.b957b7c0.svg";
export { ForwardRef as ReactComponent };